module.exports = function(content) {
    this._sendMessage('save', {content: content})
};